import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  TemplateRef,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { Observable, of } from "rxjs";
import { Subject } from "rxjs";
import { ToastService } from "ng-uikit-pro-standard";

import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";
import { GUID } from "./../../guid";
import { MatDialog } from "@angular/material";
import { TranslationService } from "src/app/translation.service";

@Component({
  selector: "app-metabuttonnew",
  templateUrl: "./metabuttonnew.component.html",
  styleUrls: ["./metabuttonnew.component.scss"],
})
export class MetabuttonNewComponent implements OnInit {
  @ViewChild("translateDialog", { static: false })
  translateDialog!: TemplateRef<any>;

  metabutton: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metabuttonId = "";
  name = "";
  metaobjectId = "";
  metaobjectName = "";
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject = false;

  mode = "New";
  guid: GUID;
  profiles: any;

  buttonAttributesDefnArr: any[];
  buttonAttributeArray = [];

  buttonTypeSelect = [];

  buttonActionTypeSelect = [];

  displayTypeSelect = [];

  behaviourTypeSelect = [];

  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    id: "",
    labelname: "",
    name: "",
    buttontype: "",
    actiontype: "",
    parentobjectid: new FormControl({ value: "", disabled: true }),
    parentobjectname: new FormControl({ value: "", disabled: true }),
    description: "",
    embeddedobject: new FormControl({ value: false, disabled: true }),
    active: true,
    attributes: {},
  });

  attributeForm: FormGroup;
  attributeitems: FormArray;
  dialogRef: any;
  languages: any[];
  data: any;
  translatedLabels: any;
  modifiedby: any;
  modifieddate: any;

  createItem(a: any, t: any, v: any, p = "",h:any): FormGroup {
    return this.fb.group({
      attr: a,
      type: t,
      value: v,
      placeholder: p,
      hint:h
    });
  }

  addAttributeItem(a: any, t: any, v: string | boolean, p = "",h:any): void {
    this.attributeitems = this.attributeForm.get("attributeitems") as FormArray;
    this.attributeitems.push(this.createItem(a, t, v, p,h));
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService,
    public dialog: MatDialog,
    private translationService: TranslationService
  ) {}
  translateForm: FormGroup;

  ngOnInit() {
    console.log(this.data);
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metabuttonId = this.route.snapshot.params.id;
      this.name = this.route.snapshot.params.name;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;

      this.parentobjectId = this.route.snapshot.params.parentobjectid;
      if (this.parentobjectId == "none") this.parentobjectId = "";
      this.parentobjectName = this.route.snapshot.params.parentobjectname;
      if (this.parentobjectName == "none") this.parentobjectName = "";

      this.detailForm.controls["parentobjectid"].setValue(this.parentobjectId);
      this.detailForm.controls["parentobjectname"].setValue(
        this.parentobjectId
      );

      //always convert string to boolean while assigning to formcontrol ****
      var boolValue = this.route.snapshot.params.embeddedobject == "true";
      this.embeddedObject = boolValue;
      this.detailForm.controls["embeddedobject"].setValue(this.embeddedObject);
    });

    this.attributeForm = this.fb.group({
      buttonid: "",
      name: "",
      attributeitems: this.fb.array([]),
    });

    this.guid = new GUID();

    console.log("mode", this.mode);

    //load button attributes definition
    this.buttonAttributesDefnArr = this.appConfig.buttonAttributes;

    //create button type picklist from buttontypes
    for (let i = 0; i < this.appConfig.buttonTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.buttonTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.buttonTypeSelect.push({
        value: this.appConfig.buttonTypes[i],
        label: strLabel,
      });
    }

    //create button action type picklist from buttonactiontypes
    for (let i = 0; i < this.appConfig.buttonActionTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.buttonActionTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.buttonActionTypeSelect.push({
        value: this.appConfig.buttonActionTypes[i],
        label: strLabel,
      });
    }

    //create display list from displaytypes
    for (let i = 0; i < this.appConfig.buttonDisplayTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.buttonDisplayTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.displayTypeSelect.push({
        value: this.appConfig.buttonDisplayTypes[i],
        label: strLabel,
      });
    }

    //create behaviour list from behaviourtypes
    for (let i = 0; i < this.appConfig.buttonBehaviourTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.buttonBehaviourTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.behaviourTypeSelect.push({
        value: this.appConfig.buttonBehaviourTypes[i],
        label: strLabel,
      });
    }

    if (this.mode.toLowerCase() == "new") {
      //assign default button type, action type
      this.detailForm.controls["buttontype"].setValue("Common");
      this.detailForm.controls["actiontype"].setValue("CustomView");
      this.loadAttributes();
    } else if (this.mode.toLowerCase() == "edit") {
      this.getMetabuttonById();
    }

    this.translateForm = this.fb.group({
      translate: this.fb.array([]),
      code: "",
      language: "",
    });

    // Initialize with one language by default
    this.addLang();
    this.getLanguage();
    this.getTranslationLabelById();
  }

  getLanguage() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allLanguages = res.data.orglanguage;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allLanguages.length; i++) {
              objArr.push({
                value: allLanguages[i].code,
                label: allLanguages[i].language,
              });
            }
            this.languages = objArr;

            this.isLoading = false;
          } else {
            console.log("error while deleting");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }
  // languages: string[] = ["English", "es", "French", "German"];
  // selectedLanguage: string = "es";
  translatedText: string = "";

  // translateForm = new FormGroup({
  //   translate: new FormArray([
  //     new FormGroup({
  //       selectedLanguage: new FormControl(""),
  //       translatedText: new FormControl(""),
  //       // number: new FormControl(''),
  //       // email: new FormControl('')
  //     }),
  //   ]),

  // });

  translatingDialog(labelname: any): void {
    console.log("labelname", labelname);

    if (!labelname) {
      return;
    }

    this.translateForm.patchValue({ label: labelname });
    this.data = {
      labelname: labelname,
    };

    this.dialogRef = this.dialog.open(this.translateDialog, {
      data: this.data,
      height: "400px",
      width: "800px",
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
      }
    });
  }

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required],
    });

    this.translate.push(translateGroup);
  }

  // translator() {
  //   const selectedLanguage =
  //     this.translateForm.value.translate[0].selectedLanguage;
  //   const labelname = this.data.labelname;
  //   console.log(selectedLanguage);
  //   console.log(this.translateForm.value.translate);
  //   this.translationService
  //     .translate(labelname, selectedLanguage)
  //     .subscribe((response: any) => {
  //       this.translatedText = response.data.translations[0].translatedText;
  //     });
  // }
  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.data.labelname;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }
  saveTranslated() {
    // console.log(this.translateForm);
    if (this.translateForm.valid) {
      // Handle the form submission
      console.log("Saving form data:", this.translateForm.value.translate);

      this.translatedLabels = this.translateForm.value.translate;
    }
    this.dialogRef.close();
  }
  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  close() {
    this.dialogRef.close();
  }

  getTranslationLabelById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metabuttonlabeltranslation: {
          metabuttonid: this.metabuttonId,
        },
      },
    };

    this.isLoading = true;
    this.dataService.getButtonTranslationLabelById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // Loop through the response and add translation fields
          if (res.data.metabuttonlabeltranslation) {
            this.translate.clear();
            res.data.metabuttonlabeltranslation.forEach((translation) => {
              const translateGroup = this.fb.group({
                languageCode: [translation.languagecode, Validators.required],
                translatedName: [
                  translation.translatedlabel,
                  Validators.required,
                ],
              });
              this.translate.push(translateGroup);
            });
            // After populating translateForm, update translatedLabels
            this.translatedLabels = res.data.metabuttonlabeltranslation.map(
              (translation) => ({
                languageCode: translation.languagecode,
                translatedName: translation.translatedlabel,
              })
            );
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  metaobjectDetail() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  loadAttributes() {
    this.buttonAttributeArray = this.buttonAttributesDefnArr;
    if (this.attributeitems != undefined) this.attributeitems.clear();

    //create new formarry for button attributes
    var fgArray = new Array<FormGroup>();
    //transform json to attribute form controls
    for (let i = 0; i < this.buttonAttributeArray.length; i++) {
      var item = this.buttonAttributeArray[i];
      console.log(item);
      if (this.mode.toLocaleLowerCase() == "new") {
        if (item.type.toLocaleLowerCase() == "boolean") {
          this.addAttributeItem(item.attr, item.type, false,"",item.hint);
        } else {
          this.addAttributeItem(item.attr, item.type, "","",item.hint);
        }
      } else if (this.mode.toLocaleLowerCase() == "edit") {
        //get value from the attributes
        var value = this.metabutton.attributes[item.attr];
        if (value instanceof Array) {
          value = JSON.stringify(value);
        }
        this.addAttributeItem(item.attr, item.type, value,"",item.hint);
      }
    }
    if (this.mode.toLocaleLowerCase() == "new") {
      //set default value
      var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
      console.log(this.attributeForm.get("attributeitems"));
      for (let c of arrayControl.controls) {
        console.log(c);

        if (c.get("attr").value == "displaytype") {
          c.get("value").setValue("Button");
          console.log('Display Type Set:', c.get('value').value);

          // break;
        }
        console.log("************", c);
        if (c.get("attr").value == "behaviourtype") {

          c.get("value").setValue("updatedata");
          console.log('Behaviour Type Set:', c.get('value').value);

          break;
        }
      }
    }
    console.log(this.displayTypeSelect);
console.log(this.behaviourTypeSelect);
console.log(this.attributeForm.value);

  }

  getMetabuttonById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metabutton: {
          id: this.metabuttonId,
        },
      },
    };

    this.isLoading = true;
    this.dataService.getMetabuttonById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.metabutton = res.data.metabutton;
          if (this.metabutton != null) {
            this.metaobjectId = this.metabutton.metaobjectid;
            this.metaobjectName = this.metabutton.metaobjectname;

            this.detailForm.controls["metaobjectid"].setValue(
              this.metabutton.metaobjectid
            );
            this.detailForm.controls["metaobjectname"].setValue(
              this.metabutton.metaobjectname
            );
            this.detailForm.controls["id"].setValue(this.metabutton.id);
            this.detailForm.controls["labelname"].setValue(
              this.metabutton.labelname
            );
            this.detailForm.controls["name"].setValue(this.metabutton.name);
            this.detailForm.controls["buttontype"].setValue(
              this.metabutton.buttontype
            );
            this.detailForm.controls["actiontype"].setValue(
              this.metabutton.actiontype
            );
            this.detailForm.controls["parentobjectid"].setValue(
              this.metabutton.parentobjectid
            );
            this.detailForm.controls["parentobjectname"].setValue(
              this.metabutton.parentobjectname
            );
            this.detailForm.controls["description"].setValue(
              this.metabutton.description
            );
            this.detailForm.controls["embeddedobject"].setValue(
              this.metabutton.embeddedobject
            );
            this.detailForm.controls["active"].setValue(this.metabutton.active);
            this.detailForm.controls["attributes"].setValue(
              this.metabutton.attributes
            );

            this.modifiedby = this.metabutton.modifiedby;
            this.modifieddate = this.metabutton.timezone;

            this.buttonAttributeArray = this.buttonAttributesDefnArr;
            console.log("attributes", this.metabutton.attributes);

            var fgArray = new Array<FormGroup>();
            //transform json to attribute form controls
            for (let i = 0; i < this.buttonAttributeArray.length; i++) {
              var item = this.buttonAttributeArray[i];

              //get value from the attributes
              var value = this.metabutton.attributes[item.attr];
              if (value instanceof Array) {
                value = JSON.stringify(value);
              }
              this.addAttributeItem(item.attr, item.type, value,"",item.hint);
            }
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  save() {
    this.isLoading = false;
    this.isError = false;
    if (this.detailForm.controls["labelname"].value.toString().trim() == "") {
      this.showWarning("Button label is mandatory");
      return;
    }
    if (this.detailForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Button name is mandatory");
      return;
    }
    if (this.detailForm.controls["buttontype"].value.toString().trim() == "") {
      this.showWarning("Button type is mandatory");
      return;
    }
    if (this.detailForm.controls["actiontype"].value.toString().trim() == "") {
      this.showWarning("Button actiontype is mandatory");
      return;
    }

    if (this.detailForm.invalid) {
      this.errorMessage =
        "The fields [Name], [Label], [Type], and [Action Type] are mandatory.";
      return;
    }
    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.metabuttonId = this.guid.getGUID("metabutton");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        metabutton: {
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          parentobjectid: this.parentobjectId,
          embeddedobject: this.embeddedObject,
          mode: this.mode,
          id: this.metabuttonId,
          labelname: this.detailForm.controls["labelname"].value.trim(),
          name: this.detailForm.controls["name"].value.trim(),
          buttontype: this.detailForm.controls["buttontype"].value,
          actiontype: this.detailForm.controls["actiontype"].value,
          description: this.detailForm.controls["description"].value.trim(),
          active: this.detailForm.controls["active"].value,
          attributes: {},
          buttonlabeltranslation: [],
        },
      },
    };

    //formulate button attributes and assign it to postoption
    //get formarray details
    var attrbs = {};

    var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    for (let c of arrayControl.controls) {
      attrbs[c.get("attr").value] = c.get("value").value;
    }

    //push attributes to request data (postoption)
    postOption.data.metabutton.attributes = attrbs;

    if (this.mode.toLocaleLowerCase() == "edit") {
      var arrtranslatedButtons = [];
      for (let translatedbuttonlabel of this.translatedLabels) {
        var buttonlabelTranslation = {
          id: this.guid.getGUID("metabuttonlabeltranslation"),
          organizationid: localStorage.getItem("crm_orgid"),
          metabuttonid: this.metabuttonId,
          languagecode: translatedbuttonlabel.languageCode,
          translatedlabel: translatedbuttonlabel.translatedName,
          active: true,
        };

        //push it to array
        arrtranslatedButtons.push(buttonlabelTranslation);
      }
      postOption.data.metabutton.buttonlabeltranslation = arrtranslatedButtons;
    }

    console.log("postOption", postOption);

    this.isLoading = true;
    this.dataService.upsertMetabutton(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/metabuttondetail/" +
              this.metabuttonId +
              "/" +
              this.detailForm.controls["name"].value.trim() +
              "/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName +
              "/" +
              (this.parentobjectId == "" ? "none" : this.parentobjectId) +
              "/" +
              (this.parentobjectName == "" ? "none" : this.parentobjectName) +
              "/" +
              this.embeddedObject
          );
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
